'use client';

import { redirect } from 'next/navigation';

import { FormattedMessage } from '@flipster/i18n';
import { stack } from '@flipster/styled-system/patterns';
import { checkAxiosError } from '@flipster/utils/axios';

import { ErrorBoundaryProps } from './error';

// test 용 아예 호출이되지 않는것같지만...
const GlobalError = ({ error }: ErrorBoundaryProps) => {
  const isAxiosError = checkAxiosError(error);
  const isMaintenance = isAxiosError && error.response?.status === 503;

  if (isMaintenance) redirect('/maintenance');

  return (
    <html lang='en'>
      <body>
        <div className={stack({ h: '100vh', justify: 'center', textStyle: 'Text/L/Regular', textAlign: 'center' })}>
          <p>
            <FormattedMessage id='Autogen_common.r251126.s_Something_wrong' />
          </p>
          {isAxiosError && <p>{JSON.stringify(error.response?.data.error ?? {})}</p>}
        </div>
      </body>
    </html>
  );
};

export default GlobalError;
